import { render, staticRenderFns } from "./RadarChartBackgroundWheel.vue?vue&type=template&id=577b277e&scoped=true"
import script from "./RadarChartBackgroundWheel.vue?vue&type=script&lang=js"
export * from "./RadarChartBackgroundWheel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577b277e",
  null
  
)

export default component.exports